import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal modal-xl" }
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdDetail = _resolveComponent("AdDetail")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "modal-close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_AdDetail, {
                adFrontId: _ctx.adFrontId,
                isPreview: true
              }, null, 8, ["adFrontId"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}